import { combineReducers } from 'redux';
import SignInTemplate from './SignInTemplate';
import Seller from './Seller';
import State from './State';
import User from './User';
import Catalog from './Catalog';

const RootReducer = combineReducers({ SignInTemplate, Seller, State,User,Catalog });
export default RootReducer;
